import { render, staticRenderFns } from "./assigned-tasks-form.vue?vue&type=template&id=588f92c6&"
import script from "./assigned-tasks-form.vue?vue&type=script&lang=js&"
export * from "./assigned-tasks-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports